import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

import { api_crud_route, api_list_route, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../Utils';

import { getTokenInfo } from '../../UseToken';
import UseSidebar from '../../UseSidebar';

import Loader from '../Loader/Loader';

import Swal from 'sweetalert2'
import Hosts from '../../Hosts'
import { language } from './Language';
import { color } from "../WEBContent/Color";
import { icon } from "../WEBContent/Icon"

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])
    // const [permissions, set_permissions] = useState({})

    const [, setRefresh] = useState(0)

    const [entities, setEntities] = useState([]);
    const [projetos, setProjetos] = useState([]);
    const [responsaveis, setResponsaveis] = useState([]);

    const [selectedButton, setSelectedButton] = useState(null);
    const [filteredData, setFilteredData] = useState(data);
    const [isFilterPedidos, setIsFilterPedidos] = useState(false);
    const [isFilterConcluidos, setIsFilterConcluidos] = useState(false);
    const [clickedHeaders, setClickedHeaders] = useState({});
    const [sortDirection, setSortDirection] = useState(true);

    const object_type = 'projetos'

    const handleHeaderClick = (header) => {
        setClickedHeaders((prevState) => {
            const isNumber = !isNaN(header);

            const sortedState = Object.keys(prevState)
                .sort((a, b) => {
                    if (isNumber) {
                        return a.localeCompare(b);
                    } else {
                        return parseFloat(a) - parseFloat(b);
                    }
                })
                .reduce((acc, key) => {
                    acc[key] = prevState[key];
                    return acc;
                }, {});

            return {
                ...sortedState,
                [header]: !prevState[header],
            };
        });
    };

    const handlePrioridade = (header) => {
        setSortDirection((prevDirection) => !prevDirection);

        const normalOrder = ['Crítico', 'Urgente', 'Normal', 'Pouco Urgente', 'Não Urgente', 'Sem Prioridade'];
        const invertedOrder = ['Sem Prioridade', 'Não Urgente', 'Pouco Urgente', 'Normal', 'Urgente', 'Crítico'];

        const order = sortDirection ? normalOrder : invertedOrder;

        const sortedData = [...filteredData].sort((a, b) => {
            const priorityA = order.indexOf(a.info.prioridade?.labelPt || 'Sem Prioridade');
            const priorityB = order.indexOf(b.info.prioridade?.labelPt || 'Sem Prioridade');

            return priorityA - priorityB;
        });

        setFilteredData(sortedData);

        setClickedHeaders((prevState) => ({
            ...prevState,
            [header]: !prevState[header],
        }));
    };

    const fetch_id_info = async () => {
        reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                console.log("Tickets criados", res.data)
                setData(res.data)


            })
            .catch(() => 404
            )
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create === false) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit === false) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove === false) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create === false) {
                            aux.create = node.create
                        }
                        if (aux.edit === false) {
                            aux.edit = node.edit
                        }
                        if (aux.remove === false) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)
                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {
        setFilteredData(data);
        //console.log("TICKETS", data);
    }, [data]);

    useEffect(() => {

        (async () => {

            await fetch_id_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    useEffect(() => {
        const fetchResponsaveis = async () => {
            try {
                const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/`);
                const responsaveisOptions = res.data
                    .filter(entity => entity.entity_type === "1")
                    .map(entity => ({
                        id: entity.id,
                        nome: entity.name
                    }));

                setResponsaveis(responsaveisOptions);
                //console.log("Responsaveis:", responsaveisOptions);
            } catch (error) {
                console.error("Erro:", error);
            }
        };

        const fetchEntities = async () => {
            try {
                const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/`);
                const entitiesOptions = res.data
                    .filter(entity => entity.entity_type === "2")
                    .map(entity => ({
                        id: entity.id,
                        nome: entity.name
                    }));

                setEntities(entitiesOptions);
                //console.log("Entities:", entitiesOptions);
            } catch (error) {
                console.error("Erro:", error);
            }
        };

        const fetchProjetos = async () => {
            try {
                const res = await reqGET(Hosts.SIMCore_API + '/intranet/projetos/' + getTokenInfo().companycode);
                const projetosOptions = res.data.map(projeto => ({
                    id: projeto.id,
                    name: projeto.info.nome[0]?.nomeCompleto || '',
                    empresa: projeto.info.empresa,
                }));

                //console.log('Projetos', projetosOptions);
                setProjetos(projetosOptions);

            } catch (error) {
                console.error("Erro ao buscar os tipos de utilizadores:", error);
            }
        };

        fetchResponsaveis();
        fetchEntities();
        fetchProjetos();

    }, []);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: color.corPrimaria.rgb,
            cancelButtonColor: color.corVermelha.rgb,
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })

    }

    const handleButtonClick = (buttonType) => {
        if (buttonType === selectedButton) {
            setSelectedButton(null);
            setIsFilterPedidos(false);
            setIsFilterConcluidos(false);
            setFilteredData(data);
        } else {
            setSelectedButton(buttonType);

            switch (buttonType) {
                case 'pedidos':
                    filterPedidos();
                    setIsFilterConcluidos(false);
                    break;
                case 'concluidos':
                    filterConcluidos();
                    setIsFilterPedidos(false);
                    break;
                default:
                    break;
            }
        }
    };

    const getPrioridadeStyle = (estado) => {
        switch (estado) {
            case 'Normal':
                return { color: color.corNormal.rgb } // Azul
            case 'Urgente':
            case 'Urgent':
                return { color: color.corUrgente.rgb }; // Laranja Claro
            case 'Crítico':
            case 'Critical':
                return { color: color.corCritica.rgb } // Vermelho Claro
            case 'Pouco Urgente':
            case 'Low Priority':
                return { color: color.corPoucoUrgente.rgb } // Verde Claro
            case 'Não Urgente':
            case 'Not Urgent':
                return { color: color.corNaoUrgente.rgb } // Lima
            default:
                return { color: color.cor4.rgb } // Cinza
        }
    };

    const traduzirPrioridadeParaEstilo = (prioridade, lang) => {
        const prioridadesMapeadas = {
            en: {
                'Normal': 'Normal',
                'Urgent': 'Urgente',
                'Critical': 'Crítico',
                'Low Priority': 'Pouco Urgente',
                'Not Urgent': 'Não Urgente',
            },
            pt: {
                'Normal': 'Normal',
                'Urgente': 'Urgente',
                'Crítico': 'Crítico',
                'Pouco Urgente': 'Pouco Urgente',
                'Não Urgente': 'Não Urgente',
            },
        };
        return prioridadesMapeadas[lang]?.[prioridade] || prioridade;
    };

    const toggleFilter = (isActive, filterCondition, setFunction) => {
        setFunction(isActive ? data : data.filter(filterCondition));
    };

    const filterPedidos = () => {
        toggleFilter(isFilterPedidos, ticket => ticket.info.estado === false, setFilteredData);
        setIsFilterPedidos(!isFilterPedidos);
    };

    const filterConcluidos = () => {
        toggleFilter(isFilterConcluidos, ticket => ticket.info.estado === true, setFilteredData);
        setIsFilterConcluidos(!isFilterConcluidos);
    };

    const formatDateTime = date => {
        const formattedDate = date.toLocaleDateString('default', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
        const formattedTime = date.toLocaleTimeString('default', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
        return { formattedDate, formattedTime };
    };

    const traduzir = (prioridade, prioridadesTraduzidos, lang) => {
        const found = Object.values(prioridadesTraduzidos).find(item => item.pt === prioridade || item.en === prioridade);
        return found ? found[lang] : prioridade; // Retorna a tradução no idioma solicitado ou a prioridade original
    };
    const columns = [
        {
            name: language[lang].ticket_number,
            selector: 'id',
            width: '5%',
            minWidth: '50px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].prioridade,
            selector: 'info.prioridade[0].label',
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            left: true,
            cell: row => {
                const prioridade = row.info.prioridade?.[0];
                const label = lang === 'en' ? prioridade?.labelEn : prioridade?.labelPt || "Sem Prioridade"; // Obtém o rótulo no idioma atual
                const prioridadeTraduzida = traduzirPrioridadeParaEstilo(label, lang); // Traduz o rótulo para o idioma correspondente ao estilo
                const style = getPrioridadeStyle(prioridadeTraduzida); // Aplica o estilo baseado na tradução
                return (
                    <span style={{ padding: '8px', borderRadius: '4px', ...style }}>
                        {label}
                    </span>
                );
            }
        },
        {
            name: language[lang].table_date,
            selector: row => {
                const { formattedDate, formattedTime } = formatDateTime(new Date(row.info.data));
                return (
                    <div>
                        <div>{formattedDate}</div>
                        <div>{formattedTime}</div>
                    </div>
                );
            },
            width: '12%',
            minWidth: '150px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].cliente,
            selector: 'info.cliente',
            width: '15%',
            cell: row => <span>{row.info.cliente?.[0]?.label ?? "ID não encontrado"}</span>,
            sortable: true,
            left: true,
        },
        {
            name: language[lang].software,
            selector: 'info.projeto',
            width: '15%',
            cell: row => <span>{row.info.projeto?.[0]?.label ?? "ID não encontrado"}</span>,
            sortable: true,
            left: true,
        },
        {
            name: language[lang].assunto,
            selector: 'info.assunto',
            width: '20%',
            minWidth: '110px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].responsavel,
            selector: 'info.colaborador',
            width: '15%',
            cell: row => <span>{row.info.colaborador?.[0]?.label ?? "ID não encontrado"}</span>,
            sortable: true,
            left: true,
        },
        {
            name: '',
            right: true,
            export: false,
            width: '15%',
            minWidth: '110px !important',
            cell: row =>
                <span>
                    <Link
                        className="button button-update button-view d-none"
                        to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }}
                        replace
                        aria-label="View Ticket"
                    >
                        <i className="bi bi-eye"></i>
                    </Link>

                    {permissions.current !== null && (permissions.current.edit) ? (
                        <Link
                            className="button button-update"
                            to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }}
                            replace
                            aria-label="Edit Ticket"
                        >
                            <i className={icon.pencil.className} style={icon.pencil.style}></i>
                        </Link>
                    ) : null}

                    {permissions.current !== null && permissions.current.remove ? (
                        <button
                            className="button button-delete"
                            onClick={() => apagar(row['id'])}
                            aria-label="Delete Ticket"
                        >
                            <i className={icon.trash.className} style={icon.trash.style}></i>
                        </button>
                    )
                        :
                        null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data: filteredData,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <h2 className="dash-title">{language[lang].entity}</h2>
                <p>{language[lang].entity_list}</p>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">
                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body" style={{ marginLeft: '2%' }}>
                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header d-flex justify-content-between align-items-center" style={{ fontSize: '0.8rem' }}>
                                        <div className="button-group-left d-flex">
                                            <button
                                                className="btn btn-sm btn-default"
                                                onClick={() => handleButtonClick('pedidos')}
                                                style={{
                                                    color: selectedButton === 'pedidos' ? color.corPrimaria.rgb : 'inherit',
                                                    padding: '0.25rem 0.5rem',
                                                    marginRight: '0.3rem'
                                                }}
                                            >
                                                {language[lang].filter_resolver}
                                            </button>

                                            <button
                                                className="btn btn-sm btn-default"
                                                onClick={() => handleButtonClick('concluidos')}
                                                style={{
                                                    color: selectedButton === 'concluidos' ? color.corPrimaria.rgb : 'inherit',
                                                    padding: '0.25rem 0.5rem',
                                                    marginRight: '0.3rem'
                                                }}
                                            >
                                                {language[lang].filter_concluido}
                                            </button>
                                        </div>
                                        {(permissions.current !== null && permissions.current.create) && (
                                            <div className="table-header text-end mb-8">
                                                <Link className="btn rounded-pill btn-primary py-1 px-4 multi-item"
                                                    to={{ pathname: endpoints.regist }}
                                                    style={{ padding: '0.15rem 1.0rem', fontSize: '0.9rem' }}
                                                >
                                                    <span>{language[lang].add_new}</span>
                                                </Link>
                                            </div>
                                        )}
                                    </div>
                                    <div className="table-body">
                                        <DataTableExtensions {...tableData}>

                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}